import { Account } from '@order-management/types';
import InboxItem from '../../ui/inbox-table/inbox-item/inbox-item';

export type AccountInboxItemProps = {
  account: Account;
  onClick: () => void;
  active: boolean;
};

export function AccountInboxItem({
  account,
  active,
  onClick,
}: AccountInboxItemProps) {
  return (
    <InboxItem active={active} onClick={onClick}>
      <span>{account.name}</span>
    </InboxItem>
  );
}

export default AccountInboxItem;
